<template>
	<div class="fees gray-bar-top app clearfix">
		<h3 class="module-title">
			Expense Ratio
		</h3>
		<div class="row">
			<div class="col-md-12">
				<table class="table-condensed">
					<tbody>
						<tr>
							<th class="no-TB" />
							<th class="com-mod-table-data">
								{{ showNetValue ? 'Gross' : '' }}
							</th>
							<th v-if="showNetValue" class="com-mod-table-data">
								Net
							</th>
						</tr>
						<tr>
							<td class="com-mod-table-label flush-left">
								{{ symbol }}
							</td>
							<td class="com-mod-table-data">
								{{ $format.rawPercent(expenseRatioGross) }}
							</td>
							<td v-if="showNetValue" class="com-mod-table-data">
								{{ $format.rawPercent(expenseRatioNet) }}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<span class="com-mod-level-2-disclosure">Fund as of most recent prospectus. </span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'Expenses',
	computed: {
		...mapGetters([
			'expensesData',
			'getFundAttributes'
		]),
		widgetData() {
			const data = this.expensesData;
			if (data && this.getFundAttributes) {
				data.symbol = this.getFundAttributes.FundSymbol;
				data.showNetValue = typeof data.expenseRatioNet === 'number';
			}
			this.$EventBus.$emit('ExcelData', 'ExpenseModule', data);
			return data;
		},
		componentData() {
			return this.widgetData || {};
		},
		showNetValue() {
			return this.componentData.showNetValue;
		},
		expenseRatioGross() {
			return this.componentData.expenseRatioGross || '--';
		},
		expenseRatioNet() {
			return this.componentData.expenseRatioNet || '--';
		},
		symbol() {
			return this.componentData.symbol || '--';
		}
	}
};
</script>

<style lang="less" scoped>
.app {
	font-family: "AvenirNextLTW01-Regular", Arial, sans-serif;
	font-size: 14px;

	.data {
		color: #333;
		float: right;
	}

	table {
		border-collapse: collapse;
	}

	.data-row {
		color: #666;
		padding: 5px 0px;
	}

	.adjust-date {
		margin-top: 5px;
	}

	.table-condensed tr {
		border-bottom: 1px solid rgb(204, 204, 204);
	}
}

#afis-app .table-condensed tr td.com-mod-table-label {
	padding: 5px;
	text-align: left;
}

#afis-app .table-condensed tr td.com-mod-table-data {
	padding: 5px;
	text-align: right;
	width: 12%;
}

.com-mod-level-2-disclosure {
	font-size: 12px;
	font-family: "AvenirNextLTW01-Condens 721299", Arial, sans-serif;
	color: #666;
}
</style>